import { Close } from "@mui/icons-material";
import { Button, IconButton, Snackbar } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { useAppSelector } from "app/redux-store-interactions";
import { selectPicker } from "features/render";
import { PICKER_ESC_TYPES } from "hooks/useHandlePickerEsc";
import { hasMouseSupport } from "utils/misc";

const localStorageKey = "pickerEscSnackbarDismissed";

export function PickerEscSnackbar() {
    const { t } = useTranslation();
    const picker = useAppSelector(selectPicker);
    const [open, setOpen] = useState(false);
    const hasMouse = hasMouseSupport();

    useEffect(() => {
        if (!hasMouse) {
            return;
        }

        const dismissed = localStorage.getItem(localStorageKey) === "true";
        if (dismissed) {
            return;
        }

        if (PICKER_ESC_TYPES.includes(picker)) {
            setOpen(true);
        }
    }, [picker, hasMouse]);

    const handleClose = () => {
        setOpen(false);
    };

    const dismiss = () => {
        setOpen(false);
        localStorage.setItem(localStorageKey, "true");
    };

    return (
        <>
            <Snackbar
                open={open}
                autoHideDuration={null}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                sx={{
                    width: { xs: "auto", sm: 350 },
                    bottom: { xs: "auto", sm: 88 },
                    top: { xs: 24, sm: "auto" },
                    pointerEvents: "auto",
                }}
                onClose={handleClose}
                message={
                    <>
                        {t("press") + " "}
                        <kbd>Escape</kbd>
                        {" " + t("toExitCurrentSelectionMode")}.
                    </>
                }
                action={
                    <>
                        <Button color="primary" size="small" variant="text" type="button" onClick={dismiss}>
                            {t("doNotShowAgainUppercase")}
                        </Button>
                        <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
                            <Close fontSize="small" />
                        </IconButton>
                    </>
                }
            />
        </>
    );
}
